import classNames from 'classnames';
import * as React from 'react';

import css from './BooksTextButton.module.scss';

interface Props extends React.HTMLProps<HTMLButtonElement> {
  className?: string;
  onClick?: () => void;
  value?: string;
}

const BooksTextButton = ({ className, children, onClick, value }: Props) => {
  const classes = classNames(css.BooksTextButton, className);

  return (
    <button className={classes} onClick={onClick} value={value}>
      {children}
    </button>
  );
};

export default BooksTextButton;
